import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { useContext, useEffect } from 'react';
import { HistoryStoreContext } from '../../../ContextProviders/HistoryStoreContext';
import { AppMainViewContext } from '../.././../ContextProviders/AppContextProvider';
import { useKeySelector } from '../.././../hooks/useKeySelector';
import { ObservationsContext } from '../Contexts/OvesrvationsContextType_V2';
import { ObservationInputMetaKeys } from '../fns';
import { DialogWrapper } from '../../common/DiaglogWrapper';
import { ActionIcons } from '../../../Iconography';
import { KeyBucketStrategySelector } from './KeyBucketStrategySelector';
const debug = process.env.REACT_APP_DEBUG && false;
export const ManageKeys = (props) => {
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const { state: ObservationContextState, dispatch } = useContext(ObservationsContext);
    const { historyStoreFns: { setTimePeriod }, } = useContext(HistoryStoreContext);
    const { observationHistory, objectHistory, selectedKeys, requestedDeleteKeys } = ObservationContextState;
    const observationHistoryStore = observationHistory?.observedHistory ?? null;
    debug && console.log('historyStore', observationHistoryStore);
    const observationKeys = (observationHistoryStore?.keys() ?? []).filter((k) => !ObservationInputMetaKeys.includes(k));
    const { component: KeySelector, attributeKeys, requiredKeys, setRequiredKeys, } = useKeySelector({ initialKeys: objectHistory?.recentStateHistory?.keys(), initialRequiredKeys: selectedKeys ?? [], sort: true });
    useEffect(() => {
        const requestRemoveKeys = observationKeys.filter((k) => !requiredKeys.includes(k));
        if (requestRemoveKeys.length > 0) {
            const action = { type: 'requestDeleteKeys', value: requestRemoveKeys };
            dispatch(action);
        }
        const addKeys = requiredKeys.filter((k) => !observationKeys.includes(k));
        if (addKeys.length > 0) {
            const action = { type: 'addKeys', value: addKeys };
            dispatch(action);
        }
    }, [requiredKeys]);
    const handleConfirmRemoveKeys = () => {
        if (requestedDeleteKeys) {
            const action = { type: 'removeKeys', value: requestedDeleteKeys };
            dispatch(action);
            const closeAction = { type: 'requestDeleteKeys', value: null };
            dispatch(closeAction);
        }
    };
    return (_jsxs(Stack, { gap: 1, children: [observationKeys.length === 0 ? (_jsx(Alert, { severity: 'warning', children: 'Add measurement keys' })) : (_jsx(Alert, { severity: 'info', children: 'Use the Add Observations tab to add values' })), KeySelector, _jsx(KeyBucketStrategySelector, {}), _jsx(DialogWrapper, { open: requestedDeleteKeys !== null,
                header: `Remove ${requestedDeleteKeys?.length ?? ''} keys? (${requestedDeleteKeys?.join(', ')})`,
                setClosed: () => {
                    setRequiredKeys([...requiredKeys, ...(requestedDeleteKeys ?? [])]);
                    const closeAction = { type: 'requestDeleteKeys', value: null };
                    dispatch(closeAction);
                },
                children: (_jsx(_Fragment, { children: _jsx("div", { style: { marginLeft: 'auto', marginRight: 0 }, children: _jsxs(Box, { sx: { paddingRight: 3, paddingBottom: 2 }, children: [_jsx(Typography, { children: `Are you sure you want to remove unsaved observations for these keys: ${requestedDeleteKeys?.join(', ')}? ` }), _jsx(Button, { variant: 'contained', onClick: handleConfirmRemoveKeys, endIcon: _jsx(ActionIcons.Delete, {}), children: "Remove" })] }) }) })) }, 'ObservationCardDialog')] }, "ObsControlsA"));
};
